module.exports = __webpack_public_path__ + "static/media/allergysymptoms-2_m.67b3df4c.jpg";